import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ListStyleEnum } from '@zaoblako/shared/common/enums/list-style.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable display names for {@link ListStyleEnum} enumeration values */
export const ListStyleEnumI18n: EnumI18nInterface<ListStyleEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [ListStyleEnum.FLAT]: 'Плоский',
    [ListStyleEnum.HIERARCHY]: 'Иерархия',
  },
  [I18nLocalesEnum.EN_US]: {
    [ListStyleEnum.FLAT]: 'Flat',
    [ListStyleEnum.HIERARCHY]: 'Hierarchy',
  },
};
